module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='<div>\n    <h3>Вы искали в прошлый раз</h3>\n    <div class="searchHistory__list js-history-cards"></div>\n</div>\n';
}
return __p;
};
